import { render, staticRenderFns } from "./recovery-modal.vue?vue&type=template&id=17d1a27c&scoped=true&"
import script from "./recovery-modal.vue?vue&type=script&lang=js&"
export * from "./recovery-modal.vue?vue&type=script&lang=js&"
import style0 from "./recovery-modal.vue?vue&type=style&index=0&id=17d1a27c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d1a27c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VDialog,VIcon,VTextField})
